import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Feather, Upload, Trash2 } from "lucide-react";

export function AdminChairmanSignature({ api }) {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const ref = useRef(null);

  const load = useCallback(async () => {
    try { setInfo((await api.get("/admin/settings/chairman-signature")).data); }
    catch { setInfo({ registered: false }); }
  }, [api]);
  useEffect(() => { load(); }, [load]);

  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      await api.post("/admin/settings/chairman-signature", fd,
                      { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Ink signature registered · will appear on every cert.");
      setRefreshKey((k) => k + 1);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Upload failed."); }
    finally { setBusy(false); }
  };

  const previewUrl = info?.registered
    ? `${process.env.REACT_APP_BACKEND_URL}/api/admin/settings/chairman-signature/preview?v=${refreshKey}`
    : null;

  return (
    <div className="rounded-sm border border-[#C9A961]/25 bg-[#0f0d0a] p-6" data-testid="admin-chairman-signature">
      <div className="flex items-center gap-2 mb-3">
        <Feather size={16} className="text-[#C9A961]" />
        <h3 className="font-serif text-xl text-[#F5F5F0]">Chairman's Ink Signature</h3>
      </div>
      <p className="font-body text-sm text-[#C9C9C2] leading-relaxed mb-4">
        Upload a hand-signed PNG (transparent background works best). Every
        Induction Certificate, Chairman's Letter and outbound cert will
        replace the typeset "V. Chairman" with your real ink.
      </p>
      <div className="flex items-center gap-6 flex-wrap">
        <div className="w-56 h-24 rounded-sm border border-[#C9A961]/30 bg-black/40 grid place-items-center overflow-hidden">
          {previewUrl ? (
            <img src={previewUrl} alt="Chairman signature"
              className="max-h-full max-w-full object-contain" />
          ) : (
            <span className="font-body text-xs text-[#8A8A82] italic">No signature registered</span>
          )}
        </div>
        <button onClick={() => ref.current?.click()}
          data-testid="chairman-sig-upload"
          disabled={busy}
          className="inline-flex items-center gap-2 rounded-sm bg-[#C9A961] text-black px-5 py-2.5 font-grotesk text-[10px] uppercase tracking-[0.28em] hover:bg-[#8B7333] hover:text-[#F5F5F0] transition-colors disabled:opacity-60">
          <Upload size={13} /> {busy ? "Uploading…" : (info?.registered ? "Replace signature" : "Upload signature PNG")}
        </button>
        <input hidden ref={ref} type="file" accept="image/*"
          onChange={(e) => upload(e.target.files?.[0])} />
        {info?.filename && (
          <span className="font-body text-xs text-[#8A8A82]">
            File · {info.filename}
          </span>
        )}
      </div>
    </div>
  );
}
